import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AutomationHardwareItem, AutomationVendorHardwareData, ClientDevice, EngineeringUpdateMeeting, EngineeringUpdateMeetingUserContent, FactoryNode, FactoryNodeConfig, KnowledgeDocument, LabelPrinter, LabelPrinterGroup, RobotProgram, RobotProgramGroup, SoftwareTask, Tag, UserTimeSession } from "@prism/prism-shared";

export const LoadTags = createActionGroup({
    source: 'Automation LoadTags',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ tags: Tag[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetFactoryNode = createActionGroup({
    source: 'Automation SetFactoryNode',
    events: {
        'Initial': props<{ factoryNode: FactoryNode }>(),
        'Success': props<{ factoryNode: FactoryNode }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadFactoryNodeById = createActionGroup({
    source: 'Automation LoadFactoryNodeById',
    events: {
        'Initial': props<{ factoryNodeId: string; }>(),
        'Success': props<{ factoryNode: FactoryNode; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadFactoryNodes = createActionGroup({
    source: 'Automation LoadFactoryNodes',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ factoryNodes: FactoryNode[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetFactoryNodeConfig = createActionGroup({
    source: 'Automation SetFactoryNodeConfig',
    events: {
        'Initial': props<{ factoryNodeConfig: FactoryNodeConfig; }>(),
        'Success': props<{ factoryNodeConfig: FactoryNodeConfig; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadFactoryNodeConfigById = createActionGroup({
    source: 'Automation LoadFactoryNodeConfigById',
    events: {
        'Initial': props<{ factoryNodeConfigId: string; }>(),
        'Success': props<{ factoryNodeConfig: FactoryNodeConfig; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadFactoryNodeConfigsByIds = createActionGroup({
    source: 'Automation LoadFactoryNodeConfigsByIds',
    events: {
        'Initial': props<{ factoryNodeConfigIds: string[]; }>(),
        'Success': props<{ factoryNodeConfigs: FactoryNodeConfig[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadFactoryNodeConfigsByFactoryNodeId = createActionGroup({
    source: 'Automation LoadFactoryNodeConfigsByFactoryNodeId',
    events: {
        'Initial': props<{ factoryNodeId: string; }>(),
        'Success': props<{ factoryNodeConfigs: FactoryNodeConfig[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRobotProgramGroups = createActionGroup({
    source: 'Automation LoadRobotProgramGroups',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ programGroups: RobotProgramGroup[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRobotProgramGroupById = createActionGroup({
    source: 'Automation LoadRobotProgramGroupById',
    events: {
        'Initial': props<{ programGroupId: string; }>(),
        'Success': props<{ programGroup: RobotProgramGroup; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetRobotProgramGroup = createActionGroup({
    source: 'Automation SetRobotProgramGroup',
    events: {
        'Initial': props<{ programGroup: RobotProgramGroup; }>(),
        'Success': props<{ programGroup: RobotProgramGroup; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRobotProgramsByRobotProgramGroupId = createActionGroup({
    source: 'Automation LoadRobotProgramsByRobotProgramGroupId',
    events: {
        'Initial': props<{ programGroupId: string; }>(),
        'Success': props<{ programs: RobotProgram[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRobotProgramById = createActionGroup({
    source: 'Automation LoadRobotProgramById',
    events: {
        'Initial': props<{ programId: string; }>(),
        'Success': props<{ program: RobotProgram; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const DeleteRobotProgram = createActionGroup({
    source: 'Automation DeleteRobotProgram',
    events: {
        'Initial': props<{ programId: string; }>(),
        'Success': props<{ programId: string; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetClientDevice = createActionGroup({
    source: 'Automation SetClientDevice',
    events: {
        'Initial': props<{ clientDevice: ClientDevice }>(),
        'Success': props<{ clientDevice: ClientDevice }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetLabelPrinter = createActionGroup({
    source: 'Automation SetLabelPrinter',
    events: {
        'Initial': props<{ labelPrinter: LabelPrinter }>(),
        'Success': props<{ labelPrinter: LabelPrinter }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadClientDevices = createActionGroup({
    source: 'Automation LoadClientDevices',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ clientDevices: ClientDevice[] }>(),
        'Failure': props<{ error: any }>(), // Corrected
    }
});

export const LoadLabelPrinters = createActionGroup({
    source: 'Automation LoadLabelPrinters',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ labelPrinters: LabelPrinter[] }>(),
        'Failure': props<{ error: any }>(), // Corrected
    }
});

export const LoadLabelPrinterGroups = createActionGroup({
    source: 'Automation LoadLabelPrinterGroups',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ labelPrinterGroups: LabelPrinterGroup[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetLabelPrinterGroup = createActionGroup({
    source: 'Automation SetLabelPrinterGroup',
    events: {
        'Initial': props<{ labelPrinterGroup: LabelPrinterGroup }>(),
        'Success': props<{ labelPrinterGroup: LabelPrinterGroup }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const DeleteLabelPrinterGroup = createActionGroup({
    source: 'Automation DeleteLabelPrinterGroup',
    events: {
        'Initial': props<{ labelPrinterGroupId: string }>(),
        'Success': props<{ labelPrinterGroupId: string }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadClientDeviceById = createActionGroup({
    source: 'Automation LoadClientDeviceById',
    events: {
        'Initial': props<{ clientDeviceId: string }>(),
        'Success': props<{ clientDevice: ClientDevice }>(),
        'Failure': props<{ error: any }>(), // Corrected
    }
});

export const SetClientDeviceLog = createActionGroup({
    source: 'Automation SetClientDeviceLog',
    events: {
        'Initial': props<{ log: string; location: string; }>(),
        'Success': emptyProps(),
        'Failure': props<{ error: any }>(), // Corrected
    }
});

// ==================================================================
export const SetUserTimeSession = createActionGroup({
    source: 'Admin SetUserTimeSession',
    events: {
        'Initial': props<{ userTimeSession: UserTimeSession }>(),
        'Success': props<{ userTimeSession: UserTimeSession }>(),
        'Failure': props<{ error: any }>()
    }
})
// ==================================================================
export const SetUserTimeSessions = createActionGroup({
    source: 'Admin SetUserTimeSessions',
    events: {
        'Initial': props<{ userTimeSessions: UserTimeSession[] }>(),
        'Success': props<{ userTimeSessions: UserTimeSession[] }>(),
        'Failure': props<{ error: any }>()
    }
})
// ==================================================================
export const LoadUserTimeSessions = createActionGroup({
    source: 'Admin LoadUserTimeSession',
    events: {
        'Initial': emptyProps,
        'Success': props<{ userTimeSessions: UserTimeSession[] }>(),
        'Failure': props<{ error: any }>()
    }
})
// ==================================================================
export const DeleteUserTimeSessions = createActionGroup({
    source: 'Admin DeleteUserTimeSession',
    events: {
        'Initial': props<{ userTimeSessionId: string }>(),
        'Success': props<{ userTimeSessionId: string }>(),
        'Failure': props<{ error: any }>()
    }
})
// ==================================================================
export const LoadUserTimeSessionsByIds = createActionGroup({
    source: 'Admin LoadUserTimeSessionsByIds',
    events: {
        'Initial': props<{ userTimeSessionIds: string[] }>(),
        'Success': props<{ userTimeSessions: UserTimeSession[] }>(),
        'Failure': props<{ error: any }>(),
    }
})
export const SetSoftwareTask = createActionGroup({
    source: 'Automation SetSoftwareTask',
    events: {
        'Initial': props<{ softwareTask: SoftwareTask }>(),
        'Success': props<{ softwareTask: SoftwareTask }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadSoftwareTasks = createActionGroup({
    source: 'Automation LoadSoftwareTasks',
    events: {
        'Initial': emptyProps,
        'Success': props<{ softwareTasks: SoftwareTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetEngineeringUpdateMeeting = createActionGroup({
    source: 'Automation SetEngineeringUpdateMeeting',
    events: {
        'Initial': props<{ engineeringUpdateMeeting: EngineeringUpdateMeeting }>(),
        'Success': props<{ engineeringUpdateMeeting: EngineeringUpdateMeeting }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadEngineeringUpdateMeetings = createActionGroup({
    source: 'Automation LoadEngineeringUpdateMeetings',
    events: {
        'Initial': emptyProps,
        'Success': props<{ engineeringUpdateMeetings: EngineeringUpdateMeeting[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadEngineeringUpdateMeetingById = createActionGroup({
    source: 'Automation LoadEngineeringUpdateMeetingById',
    events: {
        'Initial': props<{ meetingId: string }>(),
        'Success': props<{ engineeringUpdateMeeting: EngineeringUpdateMeeting }>(),
        'Failure': props<{ error: any }>()
    }
})


export const SetEngineeringUpdateMeetingUserContent = createActionGroup({
    source: 'Automation SetEngineeringUpdateMeetingUserContent',
    events: {
        'Initial': props<{ engineeringUpdateMeetingUserContent: EngineeringUpdateMeetingUserContent }>(),
        'Success': props<{ engineeringUpdateMeetingUserContent: EngineeringUpdateMeetingUserContent }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetEngineeringUpdateMeetingUserContents = createActionGroup({
    source: 'Automation SetEngineeringUpdateMeetingUserContents',
    events: {
        'Initial': props<{ engineeringUpdateMeetingUserContents: EngineeringUpdateMeetingUserContent[] }>(),
        'Success': props<{ engineeringUpdateMeetingUserContents: EngineeringUpdateMeetingUserContent[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadEngineeringUpdateMeetingUserContents = createActionGroup({
    source: 'Automation LoadEngineeringUpdateMeetingUserContents',
    events: {
        'Initial': emptyProps,
        'Success': props<{ engineeringUpdateMeetingUserContents: EngineeringUpdateMeetingUserContent[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadEngineeringUpdateMeetingUserContentsByMeetingId = createActionGroup({
    source: 'Automation LoadEngineeringUpdateMeetingUserContentsByMeetingId',
    events: {
        'Initial': props<{ meetingId: string }>(),
        'Success': props<{ engineeringUpdateMeetingUserContents: EngineeringUpdateMeetingUserContent[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const DeleteEngineeringUpdateMeetingUserContent = createActionGroup({
    source: 'Automation DeleteEngineeringUpdateMeetingUserContent',
    events: {
        'Initial': props<{ engineeringUpdateMeetingUserContent: EngineeringUpdateMeetingUserContent }>(),
        'Success': props<{ engineeringUpdateMeetingUserContent: EngineeringUpdateMeetingUserContent }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadKnowledgeDocuments = createActionGroup({
    source: 'Automation LoadKnowledgeDocuments',
    events: {
        'Initial': emptyProps,
        'Success': props<{ knowledgeDocuments: KnowledgeDocument[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadKnowledgeDocumentById = createActionGroup({
    source: 'Automation LoadKnowledgeDocumentById',
    events: {
        'Initial': props<{ documentId: string }>(),
        'Success': props<{ knowledgeDocument: KnowledgeDocument }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetKnowledgeDocument = createActionGroup({
    source: 'Automation SetKnowledgeDocument',
    events: {
        'Initial': props<{ knowledgeDocument: KnowledgeDocument }>(),
        'Success': props<{ knowledgeDocument: KnowledgeDocument }>(),
        'Failure': props<{ error: any }>()
    }
})

export const DeleteKnowledgeDocumentById = createActionGroup({
    source: 'Automation DeleteKnowledgeDocument',
    events: {
        'Initial': props<{ documentId: string }>(),
        'Success': props<{ documentId: string }>(),
        'Failure': props<{ error: any }>()
    }
})

// --- Automation Hardware Items (UX: "components") ---

export const LoadAutomationHardwareItems = createActionGroup({
    source: 'Automation LoadAutomationHardwareItems',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ automationHardwareItems: AutomationHardwareItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadAutomationHardwareItemById = createActionGroup({
    source: 'Automation LoadAutomationHardwareItemById',
    events: {
        'Initial': props<{ automationHardwareItemId: string }>(),
        'Success': props<{ automationHardwareItem: AutomationHardwareItem }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetAutomationHardwareItem = createActionGroup({
    source: 'Automation SetAutomationHardwareItem',
    events: {
        'Initial': props<{ automationHardwareItem: AutomationHardwareItem }>(),
        'Success': props<{ automationHardwareItem: AutomationHardwareItem }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeleteAutomationHardwareItem = createActionGroup({
    source: 'Automation DeleteAutomationHardwareItem',
    events: {
        'Initial': props<{ automationHardwareItemId: string }>(),
        'Success': props<{ automationHardwareItemId: string }>(),
        'Failure': props<{ error: any }>(),
    }
})

// --- Automation Vendor Hardware Data ---

export const LoadAutomationVendorHardwareDataByHardwareItemId = createActionGroup({
    source: 'Automation LoadAutomationVendorHardwareDataByHardwareItemId',
    events: {
        'Initial': props<{ hardwareItemId: string }>(),
        'Success': props<{ automationVendorHardwareData: AutomationVendorHardwareData[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetAutomationVendorHardwareData = createActionGroup({
    source: 'Automation SetAutomationVendorHardwareData',
    events: {
        'Initial': props<{ automationVendorHardwareData: AutomationVendorHardwareData }>(),
        'Success': props<{ automationVendorHardwareData: AutomationVendorHardwareData }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeleteAutomationVendorHardwareData = createActionGroup({
    source: 'Automation DeleteAutomationVendorHardwareData',
    events: {
        'Initial': props<{ automationVendorHardwareDataId: string }>(),
        'Success': props<{ automationVendorHardwareDataId: string }>(),
        'Failure': props<{ error: any }>(),
    }
})
